export const snapshotGamePages = (pages: any[], indexPageToEdit: number, template: any) => {
  if (!pages?.length) return pages;

  return pages.map((page, index) => {
    if (index !== indexPageToEdit) return page;

    const { files, ...templateWithoutFiles } = template ?? {};
    const filesBelongToAnotherPage = pages.some(
      (other, otherIndex) => otherIndex !== index && other?.files && other.files === files
    );

    if (!files || filesBelongToAnotherPage) {
      return { ...page, ...templateWithoutFiles };
    }

    return { ...page, ...templateWithoutFiles, files };
  });
};
